// extracted by mini-css-extract-plugin
export default {"frequency-slab-report-container":"FrequencySlabReport_frequency-slab-report-container__gL4TJ"};